package music.jammers.client.shared.component.avatar.presentation.viewmodel

import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.launch
import music.jammers.client.shared.component.BaseViewModel
import music.jammers.client.shared.component.customExceptionHandler
import music.jammers.client.shared.component.update
import music.limasoul.client.shared.navigation.Navigation
import music.limasoul.client.shared.navigation.Router
import music.limasoul.client.shared.user.domain.usecase.GetCurrentUserUseCase

class AvatarImageViewModel(
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    private val router: Router,
) : BaseViewModel() {

    internal val state: State<AvatarImageState> get() = _state
    private val _state = mutableStateOf(AvatarImageState())

    private val errorHandler = customExceptionHandler(router) { _, _ ->
        // ignore
    }

    fun onReady() {
        viewModelScope.launch(errorHandler) {
            val user = getCurrentUserUseCase.invoke()

            _state.update {
                copy(
                    user = user,
                )
            }
        }
    }

    fun onAvatarClicked() {
        router.navigateTo(Navigation.Profile)
    }
}